// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.steps-progress-bar {
  --progress_bar_width: 320px;
  --progress_bar_color: #D1D5DB;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 0 auto;
  width: var(--progress_bar_width);
}
@media (max-width: 400px) {
  .steps-progress-bar {
    --progress_bar_width: 280px;
  }
}
.steps-progress-bar::before {
  content: "";
  border-top: 2px solid var(--progress_bar_color);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: inherit;
}
.steps-progress-bar li {
  z-index: 1;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #f9fafb;
  border: 1px solid var(--progress_bar_color);
  display: flex;
  align-items: center;
  justify-content: center;
}
.steps-progress-bar li.active {
  background-color: #41C184;
  position: relative;
  box-shadow: 0 0 0px 4px #E8F4EF;
}
.steps-progress-bar li.active svg path {
  fill: var(--cl--white);
}
.steps-progress-bar li.active span {
  font-weight: 900;
}
.steps-progress-bar li span {
  position: absolute;
  top: 44px;
  width: 95px;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: var(--cl--neutral-900);
}`, "",{"version":3,"sources":["webpack://./src/scss/stepsProgressBar.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,6BAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;AAAF;AACE;EAVF;IAWI,2BAAA;EAEF;AACF;AADE;EACE,WAAA;EACA,+CAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,cAAA;AAGJ;AADE;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGJ;AAFI;EACE,yBAAA;EACA,kBAAA;EACA,+BAAA;AAIN;AAFQ;EACE,sBAAA;AAIV;AADM;EACE,gBAAA;AAGR;AAAI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;AAEN","sourcesContent":[".steps-progress-bar {\r\n  --progress_bar_width: 320px;\r\n  --progress_bar_color: #D1D5DB;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  position: relative;\r\n  margin: 0 auto;\r\n  width: var(--progress_bar_width);\r\n  @media (max-width:400px){\r\n    --progress_bar_width: 280px;\r\n  }\r\n  &::before {\r\n    content: \"\";\r\n    border-top: 2px solid var(--progress_bar_color);\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    left: 0;\r\n    width:inherit;\r\n  }\r\n  li {\r\n    z-index: 1;\r\n    width: 36px;\r\n    height: 36px;\r\n    border-radius: 50%;\r\n    background-color: #f9fafb;\r\n    border:1px solid var(--progress_bar_color);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    &.active {\r\n      background-color: #41C184;\r\n      position: relative;\r\n      box-shadow: 0 0 0px 4px #E8F4EF;\r\n      svg {\r\n        path {\r\n          fill: var(--cl--white);\r\n        }\r\n      }\r\n      span {\r\n        font-weight: 900;\r\n      }\r\n    }\r\n    span {\r\n      position: absolute;\r\n      top: 44px;\r\n      width: 95px;\r\n      text-align: center;\r\n      font-size: 16px;\r\n      line-height: 24px;\r\n      font-weight: 500;\r\n      color: var(--cl--neutral-900);\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
